
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/positions",
      function () {
        return require("private-next-pages/positions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/positions"])
      });
    }
  